import ArticleInterface from 'types/Articles';

export const getImage = (article: ArticleInterface): string | null => {
  const media = article._embedded['wp:featuredmedia'];
  if (media && media.length > 0) {
    return media[0]?.media_details?.sizes?.thumbnail?.source_url;
  }
  return null;
};
